module.exports = "<ea-dashboard-page></ea-dashboard-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaDashboard/eaDashboardPage/eaDashboardPageModule.html
// module id = 971
// module chunks = 12